// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"614":"b3eaa1e4","831":"f48b631c"}[chunkId] + ".chunk.css";
};